import { TerraceShapeId } from '@core/constants/Shape';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import { DeckBoardWidthId, TerraceObstacleId } from '@core/constants/Option';
import {
    IFormInputType,
    IDimensionUnit,
    IFormFieldShapeDimension,
    IFormFieldShape,
    IFormFieldMaterial,
    IFormFieldMultiSelector,
    IFormFieldRadioList,
} from '../../../interfaces/Form';
import { allTerraceStone, allTerraceWood } from './materialGroups';

export const fieldsTerraceShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            TerraceShapeId.SquareTerraceShape,
            TerraceShapeId.RectangleTerraceShape,
            TerraceShapeId.RoundTerraceShape,
            TerraceShapeId.LTerraceShape,
            TerraceShapeId.UTerraceShape,
            TerraceShapeId.TTerraceShape,
        ],
        required: true,
    },
    dimension: {
        options: {
            [TerraceShapeId.SquareTerraceShape]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 200 },
                    required     : true,
                    defaultValue : 100,
                },
            },
            [TerraceShapeId.RectangleTerraceShape]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Depth]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 200 },
                    required     : true,
                    defaultValue : 100,
                },
            },
            [TerraceShapeId.RoundTerraceShape]: {
                [FieldDimensionId.Radius]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 200 },
                    required     : true,
                    defaultValue : 100,
                },
            },
            [TerraceShapeId.LTerraceShape]: {
                [FieldDimensionId.Length1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Width1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Length2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Width2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
            },
            [TerraceShapeId.UTerraceShape]: {
                [FieldDimensionId.Length1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Width1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 8000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Length2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Width2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 8000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Length3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Width3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 8000 },
                    required     : true,
                    defaultValue : 3000,
                },
            },
            [TerraceShapeId.TTerraceShape]: {
                [FieldDimensionId.Width1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Length1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Width2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Length2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Width3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
                [FieldDimensionId.Length3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 1000, max: 10000 },
                    required     : true,
                    defaultValue : 3000,
                },
            },
        },
    },
};

export const fieldsTerraceStonesMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : [
            ...allTerraceStone,
        ],
        required: true,
    },
};

export const fieldsTerraceWoodMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : [
            ...allTerraceWood,
        ],
        required: true,
    },
};

export const fieldsTerraceDeckBoardShape: IFormFieldShape = {
    value   : undefined,
    options : [
        TerraceShapeId.DeckBoardGroove,
        TerraceShapeId.DeckBoardSmooth,
        TerraceShapeId.DeckBoardVein,
    ],
    required: true,
};

export const fieldTerraceDeckBoardWidth: IFormFieldRadioList = {
    value   : undefined,
    options : [
        DeckBoardWidthId.TwelveToFifteen,
        DeckBoardWidthId.FifteenToTwenty,
        DeckBoardWidthId.TwentyToTwentyFive,
    ],
    required: true,
};

export const fieldsTerraceObstacleConstraints: IFormFieldMultiSelector = {
    value   : undefined,
    options : [
        TerraceObstacleId.PlantsObstacle,
        TerraceObstacleId.StaircaseObstacle,
        TerraceObstacleId.ManholeCoverObstacle,
        TerraceObstacleId.MoundObstacle,
        TerraceObstacleId.PoolObstacle,
        TerraceObstacleId.OtherObstacle,
        TerraceObstacleId.NoObstacle,
    ],
    required: true,
};

